import React from 'react';

export default function MemorialVideo({
  fileId = '1smm04Kxa-m1TzJIn2SdKxSkSNZcJUGzl',
  title = 'Tribute Video for Theyda',
}) {
  const previewSrc = `https://drive.google.com/file/d/${fileId}/preview`;
  const viewSrc = `https://drive.google.com/file/d/${fileId}/view`;

  return (
    <section className="video-section">
      <h2 className="video-title">{title}</h2>

      <div className="video-wrapper">
        <iframe
          className="video-iframe"
          src={previewSrc}
          title={title}
          allow="autoplay; fullscreen"
          allowFullScreen
        />
      </div>

      <div className="video-actions">
        <a
          href={viewSrc}
          target="_blank"
          rel="noopener noreferrer"
          className="video-open-link"
        >
         
        </a>
      </div>
    </section>
  );
}
